export class AuthReducerModal {
  ACCESS_TOKEN = '';
  isLoader = false;
  Name = "";
  role = "";
  loginType = "";
}